import { createFileRoute } from "@tanstack/react-router";
import { queryOptions, useQuery } from "@tanstack/react-query";

import ContentPage from "@/components/contentPage";

import { UserCard } from "@/components/cards/userCard";

const userListQueryOptions = (api: any) =>
  queryOptions({
    queryKey: ["listUsers"],
    queryFn: () => api.users.listUsers(),
  });

export const Route = createFileRoute("/user/")({
  component: UserList,
  loader: ({ context: { queryClient, api } }) =>
    queryClient.prefetchQuery(userListQueryOptions(api)),
});

function UserList() {
  const { api } = Route.useRouteContext();
  const { isPending, data } = useQuery(userListQueryOptions(api));

  if (isPending || !data) return "Loading...";
  return (
    <ContentPage title={"Users"}>
      {data.map((user: any) => (
        <UserCard user={user} key={user.id} />
      ))}
    </ContentPage>
  );
}
